import actionTypes from 'SRC/modules/redux/actionTypes'

export const setSelectedPackage = selectedPackage => ({
  type: actionTypes.SET_SELECTED_PACKAGE,
  payload: selectedPackage
})
